import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MadCapImageUrlModule } from '@portal-core/general/pipes/madcap-image-url/madcap-image-url.module';
import { InlineButtonModule } from '@portal-core/ui/button/components/inline-button/inline-button.module';
import { TeamAvatarComponent } from './team-avatar.component';

@NgModule({
  imports: [
    CommonModule,
    InlineButtonModule,
    MadCapImageUrlModule,
    MatDialogModule,
    MatTooltipModule
  ],
  declarations: [
    TeamAvatarComponent
  ],
  exports: [
    TeamAvatarComponent
  ]
})
export class TeamAvatarModule { }
